import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';

class SmSeLoadMeasurementOnDemand {
    getSensorLastCommand(assetId, requestType) {
        const endpoint = formatEndpoint(endpoints.component.getSensorLastCommand, {
            assetId,
            requestType
        });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }
}

export default new SmSeLoadMeasurementOnDemand();
